import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faAngleDown, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';
import { City, CityList } from 'src/app/core/models/location.model';
import { LocationService } from 'src/app/core/services/location.service';

@Component({
  selector: 'app-city-select',
  templateUrl: './city-select.component.html',
  styleUrls: ['./city-select.component.scss',],
})
export class CitySelectComponent implements OnInit {

  isOpen: boolean = false;
  faAngleDown = faAngleDown;
  faMapMarkerAlt = faMapMarkerAlt;

  isLoading: boolean = false;
  cities: City[] = [];

  currentCity: string = '';

  constructor(
    private _router: Router,
    private _locationService: LocationService,
    private _activateRoute: ActivatedRoute
  ) {
    this._activateRoute.queryParams.subscribe({
      next: (params) => {
        const cityName = params['city'];
        if (cityName) {
          this.currentCity = cityName;
          localStorage.setItem(AppConstants.CURRENT_CITY_KEY, this.currentCity);
        }


        const { url, } = this._router;

        if (url.startsWith('/city')) {
          const city = url.split('-car-')[AppConstants.ZERO].split('/').pop();
          if (city) {
            this.currentCity = city;
            localStorage.setItem(AppConstants.CURRENT_CITY_KEY, this.currentCity);
          }
        }
      },
    });
  }

  ngOnInit(): void {
    const cityName = localStorage.getItem(AppConstants.CURRENT_CITY_KEY);
    if (cityName) this.currentCity = cityName;
    this.loadCities();
  }

  loadCities() {
    this.isLoading = true;
    this._locationService.getCities({
      isActive: true,
    }).subscribe({
      next: (data: CityList) => {
        this.cities = data.cities;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  onCitySelected(city: City) {
    localStorage.setItem(AppConstants.CURRENT_CITY_KEY, city.name);
    this.currentCity = city.name;
    if (window.location.pathname === '/') {
      this._router.navigate([], {
        queryParams: {
          city: city.name.toLowerCase(),
          page: 1,
        },
        queryParamsHandling: 'merge',
      });
    } else {
      this._router.navigateByUrl(`city/${city.name.replace(' ', '-').toLowerCase()}-car-subscription`);
    }

  }


}
